import React from "react";
import Button from "./../../../../iconosv0/src/components/Button/Button";
import { useTranslation } from "react-i18next";
import translations from "../../../../utils/language/translations.json";

import "./BannerAddCard.scss";
import logo from "../../../../assets/logo/NoTextlogotaglineEng.png";

export default function Banner({ onAddCards }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.GridViewMain?.[key]?.[currentLang] || key;

  return (
    <section className="banner" role="region">
      <div className="banner__logo">
        <img src={logo} alt="" aria-hidden="true" />
      </div>

      <div className="banner__copy">
        <h3 className="banner__title">{t("Build Your Collector Showcase")}</h3>
        <p className="banner__desc">
          {t("Join the community of collectors. Upload your cards and make them part of the Marketplace.")}
        </p>
      </div>

      <div className="banner__cta" onClick={onAddCards}>
        <Button
          className="button-instance"
          icon={false}
          size="small"
          state="default"
          text={t("Add Cards")}
          type="secondary"
        />
      </div>
    </section>
  );
}